import React from 'react';

import Button from '@asteria/component-core/button';
import { Text, Title } from '@asteria/component-core/typography';

import { TranslationService } from '@asteria/language';

const SignupBookDemo = () => {
	return (
		<div className="asteria-component__section asteria-component__section--variant-book-demo">
			<div className="asteria-component__section-inner">
				<Title size="md">
					{TranslationService.getV2([
						'auth.partner.swedbank.book-demo.title',
					])}
				</Title>
				<Text size="md">
					{TranslationService.getV2([
						'auth.partner.swedbank.book-demo.text',
					])}
				</Text>
				<div className="asteria-component__phone">
					<Text size="md">
						{TranslationService.getV2([
							'auth.partner.swedbank.book-demo.phonetext',
						])}
					</Text>
					<a
						href={TranslationService.getV2([
							'auth.partner.swedbank.book-demo.call.number',
						])}
						className="asteria-component__button asteria-component__button--variant-link asteria-component__button--size-md"
					>
						{TranslationService.getV2([
							'auth.partner.swedbank.book-demo.call.display',
						])}
					</a>
				</div>
				<div className="asteria-component__buttons-container">
					<Button
						size="md"
						label={TranslationService.getV2([
							'auth.partner.swedbank.hero.cta.label',
						])}
						variant="primary"
						href={`mailto:${TranslationService.getV2([
							'auth.partner.swedbank.hero.email.contact',
						])}?subject=${encodeURIComponent(
							TranslationService.getV2([
								'auth.partner.swedbank.hero.email.subject',
							]),
						)}&body=${encodeURIComponent(
							TranslationService.getV2([
								'auth.partner.swedbank.hero.email.body',
							]),
						)}`}
					/>
					<Text size="lg">
						{TranslationService.getV2([
							'auth.partner.swedbank.book-demo.text2',
						])}
					</Text>
				</div>
			</div>
		</div>
	);
};

export default SignupBookDemo;
